import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { API, setAuthToken } from '@/App';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_imageblaze/artifacts/5e5w021j_7D777DBC-744F-44B3-9C70-7AE1E6146D31.png";

const AuthCallback = () => {
  const navigate = useNavigate();
  const processedRef = useRef(false);

  useEffect(() => {
    const processAuth = async () => {
      // Prevent double processing
      if (processedRef.current) return;
      processedRef.current = true;

      try {
        // Extract session_id from URL hash
        const hash = window.location.hash;
        const params = new URLSearchParams(hash.substring(1));
        const sessionId = params.get('session_id');

        if (!sessionId) {
          console.error('No session_id found');
          navigate('/login', { replace: true });
          return;
        }

        // Exchange session_id for session_token
        const response = await axios.post(
          `${API}/auth/session`,
          {},
          {
            headers: { 'X-Session-ID': sessionId },
            withCredentials: true
          }
        );

        const user = response.data;
        
        // Save token to localStorage for Safari/iOS compatibility
        if (user.token) {
          setAuthToken(user.token);
        }
        
        // Set flag to skip delay in ProtectedRoute
        sessionStorage.setItem('just_authenticated', 'true');

        // Clear the hash from URL
        window.history.replaceState(null, '', window.location.pathname);

        // Redirect based on user status
        if (user.role === 'admin') {
          navigate('/admin', { replace: true, state: { user } });
        } else if (user.status === 'approved') {
          navigate('/dashboard', { replace: true, state: { user } });
        } else if (!user.has_cni || !user.phone) {
          navigate('/complete-registration', { replace: true, state: { user } });
        } else {
          navigate('/pending-approval', { replace: true, state: { user } });
        }
      } catch (error) {
        console.error('Auth callback error:', error);
        navigate('/login', { replace: true });
      }
    };

    processAuth();
  }, [navigate]);

  // Show DLV Express logo while processing
  return (
    <div className="min-h-screen bg-gray-900 flex flex-col items-center justify-center">
      <img src={LOGO_URL} alt="DLV EXPRESS" className="h-24 w-auto mb-6" />
      <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-white"></div>
      <p className="text-white mt-4 text-sm">Connexion en cours...</p>
    </div>
  );
};

export default AuthCallback;
